module.exports = __webpack_public_path__ + "static/media/img13.44f054be.jpg";